// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataQualityRulesTableScd2 } from './data-quality-rules-table-scd2';
import {
    DataQualityRulesTableScd2FromJSON,
    DataQualityRulesTableScd2FromJSONTyped,
    DataQualityRulesTableScd2ToJSON,
    DataQualityRulesTableScd2ToJSONTyped,
} from './data-quality-rules-table-scd2';

/**
 * 
 * @export
 * @interface DataQualityRulesTable
 */
export interface DataQualityRulesTable {
    /**
     * 
     * @type {string}
     * @memberof DataQualityRulesTable
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataQualityRulesTable
     */
    primaryKeyFields?: Array<string>;
    /**
     * 
     * @type {DataQualityRulesTableScd2}
     * @memberof DataQualityRulesTable
     */
    scd2?: DataQualityRulesTableScd2;
    /**
     * 
     * @type {number}
     * @memberof DataQualityRulesTable
     */
    skipHeaderRows?: number;
}

/**
 * Check if a given object implements the DataQualityRulesTable interface.
 */
export function instanceOfDataQualityRulesTable(value: object): value is DataQualityRulesTable {
    return true;
}

export function DataQualityRulesTableFromJSON(json: any): DataQualityRulesTable {
    return DataQualityRulesTableFromJSONTyped(json, false);
}

export function DataQualityRulesTableFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataQualityRulesTable {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'primaryKeyFields': json['primaryKeyFields'] == null ? undefined : json['primaryKeyFields'],
        'scd2': json['scd2'] == null ? undefined : DataQualityRulesTableScd2FromJSON(json['scd2']),
        'skipHeaderRows': json['skipHeaderRows'] == null ? undefined : json['skipHeaderRows'],
    };
}

export function DataQualityRulesTableToJSON(json: any): DataQualityRulesTable {
    return DataQualityRulesTableToJSONTyped(json, false);
}

export function DataQualityRulesTableToJSONTyped(value?: DataQualityRulesTable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'primaryKeyFields': value['primaryKeyFields'],
        'scd2': DataQualityRulesTableScd2ToJSON(value['scd2']),
        'skipHeaderRows': value['skipHeaderRows'],
    };
}
